(function () {
  "use strict";

  angular
    .module('trainerWebApp.directives')
    .directive('mfEditGroupsSidebar', mfEditGroupsSidebar);

  function mfEditGroupsSidebar() {
    return {
      restrict: 'A',
      link: function ($scope, iElement, iAttrs) {
        var select = iElement.find('#inputGroupsMultiple');
        var sidebarBorder = iElement.parents('.user-sidebar-border')[0];
        var createGroupText = $scope.createGroupText;

        var KEY = {
          TAB: 9,
          ENTER: 13
        };

        var opts = $scope.selectOptions;
        var checkHighlightedValue = false;

        var KEY = {
          TAB: 9,
          ENTER: 13,
          ESC: 27,
          SPACE: 32,
          LEFT: 37,
          UP: 38,
          RIGHT: 39,
          DOWN: 40,
          SHIFT: 16,
          CTRL: 17,
          ALT: 18,
          PAGE_UP: 33,
          PAGE_DOWN: 34,
          HOME: 36,
          END: 35,
          BACKSPACE: 8,
          DELETE: 46,
          isArrow: function (k) {
            k = k.which ? k.which : k;
            switch (k) {
              case KEY.LEFT:
              case KEY.RIGHT:
              case KEY.UP:
              case KEY.DOWN:
                return true;
            }
            return false;
          }
        };

        opts.formatResult = function (object, container, query) {
          var term = $.trim(query.term || "");
          var html = '<div title="' + _.escape(object.text) + '"' + (object.id === -1 ? ' style="font-weight: bold; text-decoration: underline"' : '') + '>';

          if (object.label && !object.hideLabelInDropDown)
            html = html + '<span>' + object.label + ': </span>';
          var startOfCriteriaInResult = object.text.toLowerCase().indexOf(term.toLowerCase());

          if (object.id === -1) {
            startOfCriteriaInResult = object.value.toLowerCase().indexOf(term.toLowerCase());
            startOfCriteriaInResult += (createGroupText + '"').length;
          }


          if (startOfCriteriaInResult > 0)
            html = html + '<span>' + _.escape(object.text).substr(0, startOfCriteriaInResult) + '</span>';
          else
            startOfCriteriaInResult = 0;

          html = html + '<span class="select2-match">' + _.escape(object.text).substr(startOfCriteriaInResult, term.length) + '</span>';
          if (object.text.length > startOfCriteriaInResult + term.length) {
            var startOfRestOfResult = startOfCriteriaInResult + term.length;
            html = html + '<span>' + _.escape(object.text).substr(startOfRestOfResult, object.text.length - startOfRestOfResult) + '</span>';
          }

          if (object.id === -1) {
            var len = (object.value || "").length;
            if (len >= 30 && len < 40) {
              html += "<span class='mf-text-length-near'>" + len + " / " + 40 + "</span>";
            } else if (len >= 40) {
              html += "<span class='mf-text-length-over'>" + len + " / " + 40 + "</span>";
            }
          }

          html = html + '</div>';
          container[0].innerHTML = html;
        };

        select.select2(opts);

        select.on('select2-highlight', function (e) {
          if (checkHighlightedValue && e.val === -1) {
            var select2 = select.select2('container').data('select2');
            var choices = select2.findHighlightableChoices();
            if (choices.length > 1) {
              select2.moveHighlight(1);
            } else if (choices.length === 1) {
              $(choices[0]).removeClass('select2-highlighted');
            }
          }
        });

        var select2 = select.select2('container').data('select2');

        select2.search.on('keydown', function (e) {
          if (!KEY.isArrow(e)) {
            checkHighlightedValue = true;
          } else {
            var index = select2.highlight();
            if (index === -1) {
              select2.highlight(0);
            }
          }
        });

        select2.search.on('keyup', function (e) {
          checkHighlightedValue = false;
        });

        select.bind("select2-selecting", function (event) {
          if (event.val === -1) {
            var searchInput = iElement.find('.select2-input');
            var term = searchInput.val();
            $scope.$apply(function () {
              $scope.addNewGroup(event.object.value, function () {
                setTimeout(function () {
                  searchInput.val('');
                  searchInput.removeClass("select2-default");
                  select.select2('open');
                });
              });
            });

            select.select2('close');
            event.preventDefault();
            return;
          }


          $scope.$apply(function () {
            $scope.addGroup(event.object);
          });
          clearInput();
          event.preventDefault();
        });

        function clearInput() {
          var searchInput = iElement.find('.select2-input');
          //var term = searchInput.val();
          select.select2('close');
          searchInput.val('');
          searchInput.removeClass("select2-default");
          select.select2('open');
        }

        select.bind('select2-open', function (event) {
          $('.select2-dropdown-size-hack').removeClass('select2-dropdown-size-hack');
          // Triggering a scroll event on the scrollable div fixes positioning of the dropdown when it opens
          // above the input.
          $(sidebarBorder).trigger('scroll');
        });

        $scope.forceCloseDropDown = function () {
          select.select2('close');
        };

        $scope.$on('$destroy', function () {
          $scope.forceCloseDropDown();
        })
      }
    }
  }

})();
